import AssignmentResponseMixin from 'trunks/vue/share/mixins/yet_another_workflow/assignment_response.js';
import ResponsesMixin from './mixin.js';

export default Vue.extend({
  mixins: [ResponsesMixin, AssignmentResponseMixin],

  template: `
    <field-list :fields='fields'
                :response='response'
                :isAdmin='isAdmin'
                :entries='response.entries'
                :editing='true'
                :disappearedFieldIds='disappearedFieldIds'
                extendClass='form-field-group'
                @valueChange='onValueChangedFunc'
                @validChange='validChange'
                ref='fieldsView'/>
  `,
});
